import React from 'react';
import { Section, Space, Container } from '../../../GlobalStyles.jsx';
import Highlight from '../../../components/Highlight';
import { BG_DARK } from '@etiquette-ui/colors';
import Img from 'gatsby-image';
import { useStaticQuery, graphql } from "gatsby";
import { apps } from "../data";
import {
  Grid,
  Image,
  AppTitle,
  AppName
} from './styles';

import useI18n from '../../../i18n/useI18n';

const ExploreTools = ({ currentPage }) => {
  const data = useStaticQuery(Apps);
  const dataimage = data.allFile.edges;

  const { translate, translateObject } = useI18n();
  const highlightTitle = {
    en: 'Explore',
    es: 'Explora'
  }
  const title = {
    en: 'our tools',
    es: 'nuestras herramientas'
  }

  const newApps = [];
  const index = apps.findIndex(item => item.img === currentPage);

  return (
    <Section color={BG_DARK}>
      <Container center>
        <Space />
        <h2 data-sal="slide-up" data-sal-easing="ease-in-circ"> <Highlight text={translateObject(highlightTitle)} />&nbsp;{translateObject(title)} </h2>
        <Grid>
          {newApps.map(app =>
            <AppName data-sal="slide-up" data-sal-easing="ease-in-circ" data-sal-duration='500'>
              <Image>
                <Img
                  fluid={dataimage[app.img].node.childrenImageSharp[0].fluid}
                  alt={dataimage[app.img].node.base}
                  className='img-container'
                  imgStyle={{
                    position: 'absolute',
                    top: '-30%',
                    left: '-39%',
                    width: '180%',
                    height: '180%',
                  }}               
                />
              </Image>
              <AppTitle>{translate(app.app)}</AppTitle>
            </AppName>
          )}
        </Grid>
      </Container>
      <Space size='100' />
    </Section>
  );
};
export default ExploreTools;

const Apps = graphql`
query AppsName {
    allFile(
      filter: {
        extension: {regex: "/(png)/"}, 
        name: {in: [
            "digitalmenu-icon",
            "managersite-icon",
            "reservations-icon",
            "surveycreator-icon",
            "dotell-icon",
            "dashboard-icon",
            "taskme-icon",
            "adminsite-icon",
            "appsinti-icon",
        ]}}
    ) {
      edges {
        node {
          base
          childrenImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;